import { useTranslation } from 'react-i18next';

import { toOptions } from 'utils/toOptions';

import { useGetDutyTypes } from '../../../../../../queries';
import ValidFromAndToSection from './ValidFromAndToSection';
import { ControlledCheckboxAutoComplete } from 'components/shared/ControlledFields';
import { useFormContext } from 'react-hook-form';
import { Box } from '@mui/material';

const DHT_ID_LIST = 'dht_id_list';
const AbsenceCheckSection = () => {
  const { control, setValue, watch } = useFormContext();
  const { data: dutyTypes } = useGetDutyTypes();
  const { t } = useTranslation('common', {
    keyPrefix: 'adminPortal.procedures.reports'
  });
  const onRemoveElement = (id: number | string) => {
    setValue(
      DHT_ID_LIST,
      watch(DHT_ID_LIST).filter((sid: number) => sid !== id),
      { shouldDirty: true }
    );
  };
  return (
    <>
      <ValidFromAndToSection />
      <Box>
        <ControlledCheckboxAutoComplete
          fullWidth
          name={DHT_ID_LIST}
          label={t('dutyType')}
          options={toOptions(dutyTypes ?? [], 'id', 'description')}
          control={control}
          idProperty="value"
          labelProperty="label"
          allowItemRemoval
          onRemoveElement={onRemoveElement}
        />
      </Box>
    </>
  );
};

export default AbsenceCheckSection;
